import {createContext, PropsWithChildren} from 'react';
import {UserProfile, UserProfileInput} from '@/repositories/beneva-api/endpoints/users';

export type UserProfileContextType = {
  profile: UserProfile;
  differentFields: string[];
  isVerified: boolean;
  isEmployee: boolean;
  isAssistant: boolean;
  isAdvisor: boolean;
  isAdvisorWithUnconfirmedStatus: boolean;
  isAssistantWithoutAdvisor: boolean;
  saveProfile: (profile: UserProfileInput) => Promise<UserProfile>;
};

export const UserProfileContext = createContext<UserProfileContextType | null>(null);

export type Props = PropsWithChildren<{
  profile: UserProfile;
}>;
